import apiClient from "../api/apiClient";

export const createPaymentOrder = async (payload) => {
    const res = await apiClient.post("/payments/create-order", payload);
    return res.data;
};

export const verifyPayment = async (payload) => {
    const res = await apiClient.post("/payments/verify", payload);
    return res.data;
};

export const markAsPaid = async (payload) => {
    const res = await apiClient.post("/payments/markaspaid", payload);
    return res.data;
};
